import gql from 'graphql-tag';

export const addUser = gql`
  mutation addUser(
    $descomplicaId: Float!
    $firstName: String
    $lastName: String
    $displayName: String
    $email: String
  ) {
    addUser(
      data: {
        descomplicaId: $descomplicaId
        firstName: $firstName
        lastName: $lastName
        displayName: $displayName
        email: $email
      }
    ) {
      id
      dexId
      descomplicaId
      firstName
      lastName
      displayName
      accessToken
    }
  }
`;

export const setSocialMediaEmail = gql`
  mutation setSocialMediaEmail($email: String!) {
    setSocialMediaUser(data: { email: $email })
  }
`;

export const setUserMicrocertificatePdfMutation = gql`
  mutation setUserMicrocertificatePdfMutation($microcertificateId: Float!) {
    setUserMicrocertificatePdfMutation(data: { microcertificateId: $microcertificateId }) {
      url
      success
      message
    }
  }
`;

export const setRecipientViewedAt = gql`
  mutation setRecipientViewedAt($recipientId: Float!) {
    setRecipientViewedAt(data: { recipientId: $recipientId }) {
      id
      viewedAt
    }
  }
`;

export const setNote = gql`
  mutation setNote(
    $id: Int
    $dexVideoId: Int!
    $dexLessonId: Int!
    $dexDisciplineId: Int!
    $videoTimeStamp: Float!
    $platform: NotePlatform!
    $text: TextInput
    $originUrl: String
  ) {
    setNote(
      data: {
        id: $id
        dexVideoId: $dexVideoId
        dexLessonId: $dexLessonId
        dexDisciplineId: $dexDisciplineId
        videoTimeStamp: $videoTimeStamp
        platform: $platform
        text: $text
        originUrl: $originUrl
      }
    ) {
      id
      profileId
      dexVideoId
      dexLessonId
      dexDisciplineId
      originUrl
      platform
      videoTimeStamp
      latestText {
        id
        markdownText
      }
      draft {
        id
        markdownText
      }
      noteSettings {
        id
        isPrivate
      }
    }
  }
`;

export const setUserSettings = gql`
  mutation setUserSettings($shouldAutoPauseVideo: Boolean!) {
    setUserSettings(data: { shouldAutoPauseVideo: $shouldAutoPauseVideo }) {
      id
      shouldAutoPauseVideo
    }
  }
`;

export const removeNote = gql`
  mutation removeNote($id: Int!) {
    removeNote(data: { id: $id }) {
      id
      platform
      videoTimeStamp
      deletedAt
    }
  }
`;

export const setUserInteraction = gql`
  mutation setUserInteraction(
    $readNoteIntroductionDate: DateTime
    $completedNoteOnboardingDate: DateTime
  ) {
    setUserInteraction(
      data: {
        readNoteIntroductionDate: $readNoteIntroductionDate
        completedNoteOnboardingDate: $completedNoteOnboardingDate
      }
    ) {
      id
      readNoteIntroductionDate
      completedNoteOnboardingDate
    }
  }
`;

export const updateNoteDexFields = gql`
  mutation updateNoteDexFields($courseId: Int!, $profileId: Int!) {
    updateDexFields(courseId: $courseId, profileId: $profileId) {
      data {
        id
        dexVideoId
        dexLessonId
        dexDisciplineId
      }
      errors
    }
  }
`;

export const setSharedNotebook = gql`
  mutation setSharedNotebook($dexDisciplineId: Int!) {
    setSharedNotebook(data: { dexDisciplineId: $dexDisciplineId }) {
      id
      dexDisciplineId
      generatedLink
    }
  }
`;

export const copyNote = gql`
  mutation copyNote($id: Int!, $platform: NotePlatform!, $originUrl: String!) {
    copyNote(data: { id: $id, platform: $platform, originUrl: $originUrl }) {
      id
      profileId
      dexVideoId
      dexLessonId
      dexDisciplineId
      originUrl
      platform
      videoTimeStamp
      latestText {
        id
        markdownText
      }
      draft {
        id
        markdownText
      }
      noteSettings {
        id
        isPrivate
      }
    }
  }
`;
export const purgeUserAllAccess = gql`
  mutation purgeUserAllAccess($userId: Float!) {
    result: purgeUserAllAccess(userId: $userId) {
      success
    }
  }
`;
